import styled from 'styled-components'

export const Container = styled.div`
  width: 95%;
  min-width: 290px;
  max-width: 1300px;
  border-radius: 13px;
  margin: 90px auto 0;
  @media only screen and (min-width: 290px) {
    margin-top: 130px;
  }
`

export const ContentWrapper = styled.div`
  cursor: pointer;
  div {
    display: flex;
    width: auto;
    .mobile {
      position: relative;
      border-radius: 13px;
      min-width: 290px;
      width: 100%;
      height: 100%;
      margin: auto;
      margin-top: -5rem;

      @media only screen and (min-width: 601px) {
        display: none;
      }
    }
    .tablet {
      position: relative;
      border-radius: 13px;
      width: 100%;
      height: 100%;
      margin: auto;
      @media only screen and (min-width: 801px) and (max-width: 999px) {
        width: 100%;
        margin-left: 5rem;
      }
      @media only screen and (min-width: 1000px) {
        display: none;
      }
    }
  }
  .desktop {
    position: relative;
    border-radius: 13px;
    width: 100%;
    height: 100%;
    margin: auto;
    @media only screen and (min-width: 1000px) {
      width: 97%;
      margin-left: 3.5rem;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 600px) {
    .tablet {
      display: none;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 999px) {
    .desktop {
      display: none;
    }
  }
`
